import type { FC } from 'react';
import IconMdi from '@components/IconMdi';
import { mdiClose } from '@mdi/js';

import { PDFPreviewTabs } from './PDFPreviewTabs';
import { PlacementControls } from './PlacementControls';

interface PDFPreviewHeaderProps {
  isLoading: boolean;
  onClose: () => void;
}

export const PDFPreviewHeader: FC<PDFPreviewHeaderProps> = ({ isLoading, onClose }) => {
  return (
    <div className="flex flex-1 items-center text-gray-500">
      <PlacementControls />
      <PDFPreviewTabs className="flex min-w-0 flex-1 overflow-hidden pr-2" isLoading={isLoading} />
      <div className="ml-auto shrink-0">
        <IconMdi
          className="cursor-pointer transition-colors hover:text-gray-400"
          data-testid="close-pdf-button"
          onClick={onClose}
          path={mdiClose}
          title="Close preview"
        />
      </div>
    </div>
  );
};
